var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 47,
    viewBox: "0 0 73 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web Design 1",
    clipPath: "url(#clip0_3_926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67.1857 46.8706H21.1794C18.3412 46.8706 16.0317 44.5613 16.0317 41.7233V6.0179C16.0332 3.17987 18.3427 0.870605 21.1794 0.870605H67.1857C70.0239 0.870605 72.3333 3.17987 72.3333 6.0179V41.7248C72.3333 44.5628 70.0239 46.8721 67.1857 46.8721V46.8706ZM21.1794 3.11116C19.5765 3.11116 18.2724 4.41516 18.2724 6.0179V41.7248C18.2724 43.3276 19.5765 44.6316 21.1794 44.6316H67.1857C68.7885 44.6316 70.0926 43.3276 70.0926 41.7248V6.0179C70.0926 4.41516 68.7885 3.11116 67.1857 3.11116H21.1794Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.2652 42.9481C10.427 42.9481 8.11755 40.6388 8.11755 37.8008V9.94026C8.11755 7.10223 10.427 4.79297 13.2652 4.79297C13.8836 4.79297 14.3856 5.29485 14.3856 5.91324C14.3856 6.53164 13.8836 7.03352 13.2652 7.03352C11.6624 7.03352 10.3583 8.33752 10.3583 9.94026V37.8008C10.3583 39.4035 11.6624 40.7075 13.2652 40.7075C13.8836 40.7075 14.3856 41.2094 14.3856 41.8278C14.3856 42.4462 13.8836 42.9481 13.2652 42.9481Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.48103 39.3051C2.6428 39.3051 0.333374 36.9958 0.333374 34.1578V13.5836C0.333374 10.7455 2.6428 8.43628 5.48103 8.43628C6.09947 8.43628 6.60139 8.93816 6.60139 9.55655C6.60139 10.1749 6.09947 10.6768 5.48103 10.6768C3.87818 10.6768 2.57408 11.9808 2.57408 13.5836V34.1593C2.57408 35.762 3.87818 37.066 5.48103 37.066C6.09947 37.066 6.60139 37.5679 6.60139 38.1863C6.60139 38.8047 6.09947 39.3066 5.48103 39.3066V39.3051Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.264 10.6768H21.9921C21.3736 10.6768 20.8717 10.1749 20.8717 9.55655C20.8717 8.93816 21.3736 8.43628 21.9921 8.43628H66.264C66.8824 8.43628 67.3844 8.93816 67.3844 9.55655C67.3844 10.1749 66.8824 10.6768 66.264 10.6768Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.9669 7.29046C24.7267 7.29046 25.3427 6.67454 25.3427 5.91476C25.3427 5.15498 24.7267 4.53906 23.9669 4.53906C23.207 4.53906 22.5911 5.15498 22.5911 5.91476C22.5911 6.67454 23.207 7.29046 23.9669 7.29046Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.8203 7.29046C29.5801 7.29046 30.1961 6.67454 30.1961 5.91476C30.1961 5.15498 29.5801 4.53906 28.8203 4.53906C28.0604 4.53906 27.4445 5.15498 27.4445 5.91476C27.4445 6.67454 28.0604 7.29046 28.8203 7.29046Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.6722 7.29046C34.432 7.29046 35.048 6.67454 35.048 5.91476C35.048 5.15498 34.432 4.53906 33.6722 4.53906C32.9124 4.53906 32.2964 5.15498 32.2964 5.91476C32.2964 6.67454 32.9124 7.29046 33.6722 7.29046Z",
    fill: "#161718"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M38.7675 35.4049H24.0654C23.447 35.4049 22.9451 34.903 22.9451 34.2847V19.5837C22.9451 18.9653 23.447 18.4634 24.0654 18.4634H38.7675C39.3859 18.4634 39.8878 18.9653 39.8878 19.5837V34.2847C39.8878 34.903 39.3859 35.4049 38.7675 35.4049ZM25.1858 33.1644H37.6471V20.7039H25.1858V33.1644Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M64.83 20.7039H44.8757C44.2573 20.7039 43.7554 20.202 43.7554 19.5837C43.7554 18.9653 44.2573 18.4634 44.8757 18.4634H64.83C65.4484 18.4634 65.9504 18.9653 65.9504 19.5837C65.9504 20.202 65.4484 20.7039 64.83 20.7039Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M64.83 27.6795H44.8757C44.2573 27.6795 43.7554 27.1776 43.7554 26.5592C43.7554 25.9408 44.2573 25.439 44.8757 25.439H64.83C65.4484 25.439 65.9504 25.9408 65.9504 26.5592C65.9504 27.1776 65.4484 27.6795 64.83 27.6795Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M51.9415 34.6551H44.8743C44.2558 34.6551 43.7539 34.1532 43.7539 33.5348C43.7539 32.9164 44.2558 32.4146 44.8743 32.4146H51.9415C52.5599 32.4146 53.0618 32.9164 53.0618 33.5348C53.0618 34.1532 52.5599 34.6551 51.9415 34.6551Z",
    fill: "#161718"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 46,
    fill: "white",
    transform: "translate(0.333374 0.870605)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDesign);
export default __webpack_public_path__ + "static/media/Web-Design.f7d63f8c5de47f5ecce2341294080f26.svg";
export { ForwardRef as ReactComponent };